const tableCellManagementService = {
  photo: 'PHOTO'
};

export default tableCellManagementService;
